function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobcreditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6490",
    transform: "translate(-1763 -1748)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1105",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(1763 1748)",
    style: {
      fill: "#1e1e20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2506",
    d: "M417.658 163a1.658 1.658 0 0 1 1.658 1.658 1.658 1.658 0 0 1-1.658 1.658 1.658 1.658 0 0 1-1.658-1.658 1.658 1.658 0 0 1 1.658-1.658z",
    transform: "translate(1353.119 1599.684)",
    style: {
      fill: "#8aefca"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2507",
    d: "M417.658 108a1.658 1.658 0 0 1 1.658 1.658 1.658 1.658 0 0 1-1.658 1.658 1.658 1.658 0 0 1-1.658-1.658 1.658 1.658 0 0 1 1.658-1.658z",
    transform: "translate(1353.119 1650.342)",
    style: {
      fill: "#8aefca"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2508",
    d: "M417.658 53a1.658 1.658 0 0 1 1.658 1.658 1.658 1.658 0 0 1-1.658 1.658A1.658 1.658 0 0 1 416 54.658 1.658 1.658 0 0 1 417.658 53z",
    transform: "translate(1353.119 1701)",
    style: {
      fill: "#8aefca"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2509",
    d: "M472.658 163a1.658 1.658 0 0 1 1.658 1.658 1.658 1.658 0 0 1-1.658 1.658 1.658 1.658 0 0 1-1.658-1.658 1.658 1.658 0 0 1 1.658-1.658z",
    transform: "translate(1302.461 1599.684)",
    style: {
      fill: "#8aefca"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2510",
    d: "M472.658 108a1.658 1.658 0 0 1 1.658 1.658 1.658 1.658 0 0 1-1.658 1.658 1.658 1.658 0 0 1-1.658-1.658 1.658 1.658 0 0 1 1.658-1.658z",
    transform: "translate(1302.461 1650.342)",
    style: {
      fill: "#8aefca"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2511",
    d: "M472.658 53a1.658 1.658 0 0 1 1.658 1.658 1.658 1.658 0 0 1-1.658 1.658A1.658 1.658 0 0 1 471 54.658 1.658 1.658 0 0 1 472.658 53z",
    transform: "translate(1302.461 1701)",
    style: {
      fill: "#8aefca"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2512",
    d: "M527.658 108a1.658 1.658 0 0 1 1.658 1.658 1.658 1.658 0 0 1-1.658 1.658 1.658 1.658 0 0 1-1.658-1.658 1.658 1.658 0 0 1 1.658-1.658z",
    transform: "translate(1251.803 1650.342)",
    style: {
      fill: "#8aefca"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobcreditIcon);
export default __webpack_public_path__ + "static/media/mobcredit_icon.bd2633226bcd4bf5ffb10070946afd81.svg";
export { ForwardRef as ReactComponent };